import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { useState } from 'react';
import { ButtonLink, Container, Logo } from '../../design';
import { useAuthStore } from '../../store/authStore';
import { AnalyticsEvent, ctaEvent } from '../../utils/analytics';
import { AUDIENCE_PAGES, AUDIENCES, MKT, PRODUCTS } from './links';
// The wide and narrow layouts are both in the markup and CSS shows one (mk-wide / mk-narrow,
// split at 940px in marketing.css), so a prerendered page is right at any width before JS runs.
export function Nav({ dark, onToggleTheme }) {
    const [dropdown, setDropdown] = useState(false);
    const [menu, setMenu] = useState(false);
    // Hydration-safe as is: zustand renders the store's initial (signed-out) state while React
    // hydrates a prerendered page, then re-renders with the persisted sign-in.
    const isAuthenticated = useAuthStore((s)=>s.isAuthenticated);
    const signIn = isAuthenticated ? {
        href: '/app',
        label: 'Open the app'
    } : {
        href: MKT.login,
        label: 'Sign in'
    };
    return /*#__PURE__*/ _jsxs("header", {
        className: "mk-header",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "rhd-band-ai",
                children: /*#__PURE__*/ _jsxs(Container, {
                    className: "mk-topstrip__inner",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: "右 · JDM imports from Japanese auctions"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "mk-wide",
                            children: "For dealerships & individual importers"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Container, {
                className: "mk-navbar",
                children: [
                    /*#__PURE__*/ _jsx(Logo, {
                        href: MKT.home
                    }),
                    /*#__PURE__*/ _jsxs("nav", {
                        className: "mk-nav mk-wide",
                        "aria-label": "Site",
                        children: [
                            AUDIENCES.map((a)=>/*#__PURE__*/ _jsx("a", {
                                    href: MKT.audience(a),
                                    className: "mk-nav__link",
                                    "data-testid": Testids.app.marketing.navAudience(a),
                                    ...ctaEvent(AnalyticsEvent.ctaAudience, 'nav', a),
                                    children: AUDIENCE_PAGES[a].name
                                }, a)),
                            /*#__PURE__*/ _jsxs("div", {
                                style: {
                                    position: 'relative'
                                },
                                onMouseLeave: ()=>setDropdown(false),
                                children: [
                                    /*#__PURE__*/ _jsxs("button", {
                                        type: "button",
                                        className: "mk-nav__product",
                                        "aria-expanded": dropdown,
                                        onClick: ()=>setDropdown((x)=>!x),
                                        onMouseEnter: ()=>setDropdown(true),
                                        children: [
                                            "Product ",
                                            /*#__PURE__*/ _jsx("span", {
                                                style: {
                                                    fontSize: 10
                                                },
                                                children: "▾"
                                            })
                                        ]
                                    }),
                                    dropdown && /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-dropdown",
                                        children: [
                                            PRODUCTS.map((p)=>/*#__PURE__*/ _jsxs("a", {
                                                    href: MKT.product(p.slug),
                                                    className: "mk-dropdown__item",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-dropdown__k",
                                                            children: p.k
                                                        }),
                                                        /*#__PURE__*/ _jsxs("span", {
                                                            className: "mk-dropdown__text",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "mk-dropdown__name",
                                                                    children: p.name
                                                                }),
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    className: "mk-dropdown__line",
                                                                    children: p.line
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, p.slug)),
                                            /*#__PURE__*/ _jsxs("a", {
                                                href: MKT.dealerWebsites,
                                                className: "mk-dropdown__item",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-dropdown__k",
                                                        children: "網"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "mk-dropdown__text",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "mk-dropdown__name",
                                                                children: "Dealer websites"
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "mk-dropdown__line",
                                                                children: "An add-on site synced with your stock"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.guide,
                                className: "mk-nav__link",
                                children: "Guide"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.pricing,
                                className: "mk-nav__link",
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.faq,
                                className: "mk-nav__link",
                                children: "FAQ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-actions mk-wide",
                        children: [
                            /*#__PURE__*/ _jsx(ThemeToggle, {
                                dark: dark,
                                onToggle: onToggleTheme
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: signIn.href,
                                className: "mk-signin",
                                children: signIn.label
                            }),
                            /*#__PURE__*/ _jsx(ButtonLink, {
                                href: MKT.signup,
                                size: "sm",
                                "data-testid": Testids.app.marketing.navSignup,
                                ...ctaEvent(AnalyticsEvent.ctaSignup, 'nav'),
                                children: "Get started"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-actions mk-narrow",
                        children: [
                            /*#__PURE__*/ _jsx(ThemeToggle, {
                                dark: dark,
                                onToggle: onToggleTheme,
                                narrow: true
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "mk-menu-btn",
                                "aria-label": "Menu",
                                "aria-expanded": menu,
                                onClick: ()=>setMenu((x)=>!x),
                                children: menu ? 'Close' : 'Menu'
                            })
                        ]
                    })
                ]
            }),
            menu && /*#__PURE__*/ _jsxs("div", {
                className: "mk-menu mk-narrow",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "mk-menu__head",
                        children: "Who it’s for"
                    }),
                    AUDIENCES.map((a)=>/*#__PURE__*/ _jsxs("a", {
                            href: MKT.audience(a),
                            className: "mk-menu__item",
                            ...ctaEvent(AnalyticsEvent.ctaAudience, 'menu', a),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "mk-menu__k",
                                    children: AUDIENCE_PAGES[a].k
                                }),
                                AUDIENCE_PAGES[a].name
                            ]
                        }, a)),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mk-menu__head",
                        children: "Product"
                    }),
                    PRODUCTS.map((p)=>/*#__PURE__*/ _jsxs("a", {
                            href: MKT.product(p.slug),
                            className: "mk-menu__item",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "mk-menu__k",
                                    children: p.k
                                }),
                                p.name
                            ]
                        }, p.slug)),
                    /*#__PURE__*/ _jsxs("a", {
                        href: MKT.dealerWebsites,
                        className: "mk-menu__item",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "mk-menu__k",
                                children: "網"
                            }),
                            "Dealer websites"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mk-menu__links",
                        children: [
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.guide,
                                className: "mk-menu__link",
                                children: "Importing guide"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.pricing,
                                className: "mk-menu__link",
                                children: "Pricing"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.blog,
                                className: "mk-menu__link",
                                children: "Blog"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: MKT.faq,
                                className: "mk-menu__link",
                                children: "FAQ"
                            }),
                            /*#__PURE__*/ _jsx("a", {
                                href: signIn.href,
                                className: "mk-menu__link",
                                children: signIn.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ButtonLink, {
                        href: MKT.signup,
                        block: true,
                        className: "mk-menu__cta",
                        ...ctaEvent(AnalyticsEvent.ctaSignup, 'menu'),
                        children: "Get started"
                    })
                ]
            })
        ]
    });
}
/**
 * The 夜 / 昼 button, with a tooltip saying what a press will do. The tooltip repeats the
 * aria-label, so it's hidden from screen readers; Escape dismisses it until the pointer or
 * focus leaves.
 */ function ThemeToggle({ dark, onToggle, narrow }) {
    const [dismissed, setDismissed] = useState(false);
    const label = dark ? 'Switch to light mode' : 'Switch to dark mode';
    return /*#__PURE__*/ _jsxs("span", {
        className: narrow ? 'mk-theme-wrap mk-theme-wrap--narrow' : 'mk-theme-wrap',
        "data-dismissed": dismissed || undefined,
        onMouseLeave: ()=>setDismissed(false),
        onBlur: ()=>setDismissed(false),
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: narrow ? 'mk-theme mk-theme--narrow' : 'mk-theme',
                "aria-label": label,
                "data-testid": Testids.app.marketing.themeToggle(narrow ? 'narrow' : 'wide'),
                onClick: onToggle,
                onKeyDown: (e)=>{
                    if (e.key === 'Escape') setDismissed(true);
                },
                children: dark ? '昼' : '夜'
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "mk-theme-tip",
                "aria-hidden": "true",
                children: label
            })
        ]
    });
}
